import { type RefObject, useEffect } from "react";

/** Close an open menu on Escape or a click outside ``ref``. */
export const useDismiss = (
  open: boolean,
  close: () => void,
  ref: RefObject<HTMLElement>,
): void => {
  useEffect(() => {
    if (!open) return;
    const handle = (e: MouseEvent | KeyboardEvent) => {
      if (e instanceof KeyboardEvent && e.key !== "Escape") return;
      if (e instanceof MouseEvent && ref.current?.contains(e.target as Node)) return;
      close();
    };
    document.addEventListener("mousedown", handle);
    document.addEventListener("keydown", handle);
    return () => {
      document.removeEventListener("mousedown", handle);
      document.removeEventListener("keydown", handle);
    };
  }, [open, close, ref]);
};
